import { Box, InfoBadge, TaskCard } from '@medely/ui-kit';
import React from 'react';
import { TaskCardLayout } from './TaskCard';
import { useProNavigate } from '@mp/contexts';

export const PermanentPlacementCard = ({ id }: { id: number }) => {
  const { navigate } = useProNavigate();

  return (
    <TaskCardLayout>
      <TaskCard
        iconProps={{ name: 'exclamation-triangle', color: 'error' }}
        title="You have an permanent position offer to review and accept!"
        body={
          <Box alignSelf="flex-start">
            <InfoBadge label="Needs Attention" color="error" />
          </Box>
        }
        onClick={() => navigate('PermanentPlacementAvailableDetails', { id })}
      />
    </TaskCardLayout>
  );
};
